import {createArrayWithLength} from "../../helpers";
import styles from "./Rating.styles.scss";

const Rating = ({onChange, value}) => {
  const opts = createArrayWithLength(11, idx => ({isFilled: idx <= value}));

  return <div>{opts.map((v, idx) => <button className={[styles.ratingButton, v.isFilled && styles.ratingButtonActive].join(" ")} onClick={evt => onChange(idx, evt)}>{idx}</button>)}</div>;
};

export default Rating;



// WEBPACK FOOTER //
// ./components/Rating/Rating.js